import React, { useRef, useState } from "react";
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Stack from '@mui/joy/Stack';
import CardActions from '@mui/joy/CardActions';
import CardOverflow from '@mui/joy/CardOverflow';
import 'react-international-phone/style.css';
import { Button } from "primereact/button";
import { PhoneInput } from "react-international-phone";
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import { departmentOfLabourAdd, departmentOfLabourUpdate } from "../../service/departmentOfLabourService";
import MultiDropdownApi from "../../components/MultiDropdownApi";
import { emergencyContactAdd, emergencyContactUpdate } from "../../service/emergencyContactsService";

export default function EmergencyContactsAdd(modalProps: any) {
  const record = modalProps?.record;
  const [heading, setHeading] = useState(record?.heading || "");
  const [title, setTitle] = useState(record?.title || "");
  const [mobile, setMobile] = useState(record?.mobile || "");
  // const [email, setEmail] = useState(record?.email || "");
  const [description, setDescription] = useState(record?.description || "");
  const [descriptionError, setDescriptionError] = useState(false);

  const client = modalProps.client_id;

  async function addInformation() {
    const errorDescription = !description || description === '';
    // const errorLink = !link || link === '';
    setDescriptionError(errorDescription);
    // setLinkError(errorLink);
    if (errorDescription) {
      modalProps.toast.current.show({ severity: 'warn', summary: 'Please enter all required fields', life: 3000 });
      return;
    }
    modalProps.setGlobalLoading(true);
    if (modalProps.id) {
      emergencyContactUpdate(modalProps.id, {
        description, heading, title, mobile, client
      }).then((r: any) => {
        modalProps.toast.current.show({ severity: 'success', summary: 'Emergency Contacts Updated Successfully', life: 3000 });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      })
    } else {
      emergencyContactAdd({
        description, heading, title, mobile, client
      }).then((r: any) => {
        modalProps.toast.current.show({ severity: 'success', summary: 'Emergency Contacts Created Successfully', life: 3000 });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      })
    }
  }

  return (
    <React.Fragment>
      <Stack
        direction="row"
        spacing={3}
        sx={{ display: { xs: 'none', md: 'flex' }, my: 1 }}
      >
        <Stack spacing={2} sx={{ flexGrow: 1 }} style={{ width: '100%' }}>
          <Stack spacing={1}>
            <FormLabel>Heading</FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <Input size="sm" placeholder="Heading" value={heading} onChange={e => setHeading(e.target.value)} />
            </FormControl>
          </Stack>
        </Stack>
      </Stack>
      <Stack
        direction="row"
        spacing={3}
        sx={{ display: { xs: 'none', md: 'flex' }, my: 1 }}
      >
        <Stack spacing={2} sx={{ flexGrow: 1 }} style={{ width: '100%' }}>
          <Stack spacing={1}>
            <FormLabel>Title</FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <Input size="sm" placeholder="Title" value={title} onChange={e => setTitle(e.target.value)} />
            </FormControl>
          </Stack>
        </Stack>
      </Stack>
      <Stack
        direction="row"
        spacing={3}
        sx={{ display: { xs: 'none', md: 'flex' }, my: 1 }}
      >
        <Stack spacing={2} sx={{ flexGrow: 1 }} style={{ width: '100%' }}>
          <Stack spacing={1}>
            <FormLabel>Description<div style={{ color: 'red' }}>*</div></FormLabel>
            <FormControl
              error={descriptionError}
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <Input size="sm" placeholder="Description" value={description} onChange={e => setDescription(e.target.value)} />
            </FormControl>
          </Stack>
        </Stack>
      </Stack>
      <Stack direction="row" spacing={2}>
        <FormControl>
          <FormLabel>Mobile</FormLabel>
          <PhoneInput
            defaultCountry="za"
            value={mobile}
            style={{ width: '100%' }}
            onChange={e => setMobile(e)}
          />
        </FormControl>
        {/* <FormControl sx={{ flexGrow: 1 }}>
          <FormLabel>Email</FormLabel>
          <Input
            size="sm"
            type="email"
            startDecorator={<EmailRoundedIcon />}
            placeholder="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            sx={{ flexGrow: 1 }}
          />
        </FormControl> */}
      </Stack>
      <CardOverflow style={{ width: '100%' }} sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: 'flex-end', pt: 2 }}>
          <Button type="button" icon="pi pi-save" label="Save" className="p-button-outlined" size="small" style={{ position: 'absolute', fontSize: 'small', right: 0, color: "#2dd36f" }} onClick={() => addInformation()} />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}